import { styled, css } from 'styled-components';

export const EditorContent = styled.div`
  max-width: 100%;

  > div {
    display: flex;
    flex-direction: column;
    gap: 0.6em;
    overflow-wrap: anywhere;
    max-width: 100%;
    word-break: break-all;

    &:focus {
      outline: none;
    }

    > span {
      width: fit-content;
      display: block;
      height: 100%;
    }
  }
`;

export const EditorContentWrapper = styled.div<{ $disabled?: boolean }>`
  padding: 14px;
  max-width: 100%;
  color: ${({ theme }) => theme.colors.default.default};

  ${({ theme, $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      background: ${theme.colors.default[50]};
    `}
`;
